import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Table: ComponentStyleConfig = {
  baseStyle: {
    th: {
      background: '#E1E1F1',
      textTransform: 'capitalize',
    },
    td: {
      textColor: 'blue',
      borderBottom: 'none',
    },
  },
  variants: {
    simple: {
      thead: {
        th: {
          background: 'white',
          borderBottom: 'none',
          textColor: 'black',
        },
      },
      tbody: {
        td: {
          textColor: 'black',
          borderBottom: 'none',
          background: 'white',
        },
      },
    },
    striped: {
      thead: {
        th: {
          borderBottom: 'none',
          textColor: 'blue',
        },
      },
      tbody: {
        tr: {
          '&:nth-of-type(odd)': {
            td: {
              background: '#FAFAFA',
            },
          },
        },
        td: {
          background: 'gray.customGray',
          borderBottom: 'none',
        },
      },
    },
    promo: {
      thead: {
        tr: {
          '&:last-of-type': {
            th: {
              border: '1px solid #9999',
              bgColor: '#D9D9D9',
              color: 'black',
            },
          },
          th: {
            border: '1px solid #9999',
          },
        },
        th: {
          background: '#0000A3',
          color: 'white',
          textAlign: 'center',
        },
      },
      tbody: {
        tr: {
          td: {
            border: '1px solid #9999',
          },
        },
      },
    },
    promoHighlights: {
      thead: {
        tr: {
          th: {
            border: '1px solid #9999',
            background: '#0000A3',
          },
        },
        th: {
          background: '#0000A3',
          color: 'white',
          textAlign: 'center',
        },
      },
      tbody: {
        tr: {
          td: {
            border: '1px solid #9999',
          },
        },
      },
    },
  },
};
